import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  radioButtonGroup: {
    marginBottom: '4rem',
    [breakpoints.sm.down]: {
      '& label': {
        lineHeight: '3rem',
      },
      '& div[class^="wrapper"]:not(:first-child)': {
        marginTop: '2rem',
      },
    },
  },
  guidelineWrapper: {
    padding: '1rem 2rem',
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    // this color is a little lighter than blue[100]
    backgroundColor: 'rgb(235, 242, 255, 60%)',
    maxWidth: 'unset',
    '& button': {
      fontSize: '1.7rem',
      color: colors.blue[600],
      margin: 0,

      [breakpoints.sm.down]: {
        width: 'auto',
        textAlign: 'left',
      },
    },
  },
  guidelineList: {
    paddingLeft: '1.4rem',
  },
  guidelineMultiSectionContent: {
    marginTop: '1.6rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.6rem',
  },
  guidelineItem: {
    color: colors.neutral[900],
    '&:not(:last-child)': {
      marginBottom: '1rem',
    },
  },
  bcModal: {
    maxHeight: '75vh',
    margin: '7vh auto 0px',
    [breakpoints.md.down]: {
      maxWidth: '80%',
      minHeight: '75vh',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
